export const DEFAULT_CHARACTER_PLACEHOLDER = '/assets/images/kiss.webp';

export const whenImageReady = (url, existingElement = null, options = {}) => {
  const timeoutMs = options.timeoutMs ?? 10000;
  if (!url) return Promise.resolve();
  if (existingElement && existingElement.src === url && existingElement.complete) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    const timeoutId = timeoutMs > 0
      ? setTimeout(() => {
        reject(new Error('Image load timeout'));
      }, timeoutMs)
      : null;
    img.onload = () => {
      if (timeoutId) clearTimeout(timeoutId);
      resolve();
    };
    img.onerror = () => {
      if (timeoutId) clearTimeout(timeoutId);
      reject(new Error('Image load failed'));
    };
    img.src = url;
  });
};

export const loadFallbackImage = (imgElement, fallbackSrc, placeholder = DEFAULT_CHARACTER_PLACEHOLDER) => {
  if (fallbackSrc === placeholder) {
    imgElement.src = fallbackSrc;
    imgElement.style.opacity = '1';
    return;
  }

  const fallbackImage = new Image();
  fallbackImage.onload = () => {
    imgElement.src = fallbackSrc;
    imgElement.style.opacity = '1';
  };
  fallbackImage.onerror = () => {
    imgElement.src = placeholder;
    imgElement.style.opacity = '1';
  };
  fallbackImage.src = fallbackSrc;
};

export const fetchStandingSpriteFallback = async (character, outfitId) => {
  const { fetchCache } = await import('../../../js/utils/fetchCache.js');
  const { getDefaultStandingActionId } = await import('../../../js/utils/spriteFallbacks.js');
  const defaultActionId = getDefaultStandingActionId(character.gender);
  const { spriteUrl } = await fetchCache.fetchCharacterSprite(
    character.id,
    defaultActionId,
    parseInt(outfitId, 10) || 0,
    character.gender || 'female',
    false
  );
  return spriteUrl;
};

export const fetchModalCharacterSpriteUrl = async (characterId, actionId, outfitId) => {
  const { fetchCharacterSpriteUrl } = await import('../../hangout/ui/character-manager.js');
  return fetchCharacterSpriteUrl(characterId, actionId, String(outfitId), { isFullSize: false });
};
